import React from "react";
import styled from "styled-components";
import { Cross } from "../../../assets/images/Cross";
import { media } from "../../../styles/mixins";

export const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContainer>
        <CloseButton onClick={onClose}>
          <Cross />
        </CloseButton>
        {children}
      </ModalContainer>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.1);
  min-width: 80vw;
  max-width: 80vw;

  ${media.tablet(`
    min-width: 25rem;
    max-width: 35rem;
  `)}
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
